import { useMemo } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { cn } from "../../../utils/useFunctions";
import {
  PdfBalanceHeaderItemCard,
  PdfBalanceItemCard,
  PdfCard,
  PdfCardGray,
  PdfCardWhite,
} from "../component/pdf.c.card";
import PdfHeader from "../component/pdf.c.header";
import {
  PdfHeaderCardText,
  PdfHeaderText,
} from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_ITEM_TOTAL,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_BLUE_11,
  STYLE_PDF_TEXT_NORMAL_10,
  STYLE_PDF_TEXT_SEMIBOLD_BLUE_12,
  STYLE_PDF_TEXT_SEMIBOLD_BLUE_14,
} from "../styles/pdf.style";
import {
  options_property_asset,
  options_property_intangible,
  options_property_invest,
  options_property_private,
} from "../../balance/functions";
import _ from "lodash";
import numeral from "numeral";
import {
  calPropertyLocalOption,
  getAllBalanceTotal,
  getBalanceItems,
} from "../lib/pdf.lib";
import PdfFooter from "../component/pdf.c.footer";
import { useRiskStore } from "../../../_store/riskStore";

function PdfPageRiskOne({ page, balanceData }) {
  const riskData = useRiskStore((state) => state.riskData);

  const hasAccidentInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) =>
      thisItem?.options_expenses_fixed === "expenses_insuarant_accident"
  );

  const hasFireInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) => thisItem?.options_expenses_fixed === "expenses_insuarant_fire"
  );

  const hasCarInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) => thisItem?.options_expenses_fixed === "expenses_insuarant_car"
  );

  // dead
  const getRiskText = () => {
    if (riskData?.dead_sum_score === 1) {
      return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    } else if (riskData?.dead_sum_score === 1.5) {
      return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    } else if (riskData?.dead_sum_score === 2) {
      return `จากการทำแบบประเมิน แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันชีวิตและประกันสุขภาพ`;
    } else if (riskData?.dead_sum_score === 2.5) {
      return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    }
  };

  // sick
  const getSickText = () => {
    if (!riskData?.sick_sum_score) return "-";
    return `จากการทำแบบประเมินแนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันชีวิตและประกันสุขภาพ`;
  };
  const getSickDesc = () => {
    if (riskData?.sick_sum_score === 1) {
      return `จากการทำแบบประเมินแนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันสุขภาพ ถ้าท่านสุขภาพไม่ดีเกิดการเจ็บป่วยก่อนการทำประกัน บริษัทประกันจะปฏิเสธการรับประกันท่านในโรคที่เป็นมาก่อนและภาวะสืบเนื่อง`;
    } else if (riskData?.sick_sum_score === 1.5) {
      return `จากการทำแบบประเมินแนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันสุขภาพ ถ้าท่านสุขภาพไม่ดีเกิดการเจ็บป่วยก่อนการทำประกัน บริษัทประกันจะปฏิเสธการรับประกันท่านในโรคที่เป็นมาก่อนและภาวะสืบเนื่อง`;
    } else if (riskData?.sick_sum_score === 2) {
      return `จากการทำแบบประเมินแนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันสุขภาพ ดูแลสุขภาพตนเอง ทานอาหารให้ครบ 5 หมู่ ออกกำลังกายอย่างสม่ำเสมอ พักผ่อนให้เพียงพอ อยู่ในสภาพแวดล้อมที่ดี ฝึกทำสมาธิ ดูแลสติให้อยู่ในปัจจุบัน ทำจิตใจให้เบิกบาน`;
    } else if (riskData?.sick_sum_score === 2.5) {
      // return `จากกาารทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันสุขภาพ ดูแลสุขภาพตนเอง ทานอาหารให้ครบ 5 หมู่ ออกกำลังกายอย่างสม่ำเสมอ พักผ่อนให้เพียงพอ อยู่ในสภาพแวดล้อมที่ดี ฝึกทำสมาธิ ดูแลสติให้อยู่ในปัจจุบัน ทำจิตใจให้เบิกบาน`;
      return `จากการทำแบบประเมิน โอนความเสี่ยง ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันสุขภาพ ดูแลสุขภาพตนเอง ทานอาหารให้ครบ 5 หมู่ ออกกำลังกายอย่างสม่ำเสมอ พักผ่อนให้เพียงพอ อยู่ในสภาพแวดล้อมที่ดี ฝึกทำสมาธิ ดูแลสติให้อยู่ในปัจจุบัน ทำจิตใจให้เบิกบาน`;
    } else {
      return "";
    }
  };

  // disabled
  const getDisabledText = () => {
    if (!riskData?.accident_sum_score) return "-";

    if (riskData?.disable_sum_score === 1) {
      return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    }

    if (riskData?.disable_sum_score === 1.5) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสมท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    }

    if (riskData?.disable_sum_score === 2) {
      return `จากการทำแบบประเมิน แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันทุพพลภาพ`;
    }

    if (riskData?.disable_sum_score === 2.5) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันการทุพพลภาพ`;
    }
  };

  // accident
  const getAccidentText = () => {
    if (!riskData?.accident_sum_score) return "-";
    // return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;

    if (riskData?.accident_sum_score === 1) {
      return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    }

    if (riskData?.accident_sum_score === 1.5) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสมท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    }

    if (riskData?.accident_sum_score === 2) {
      return `จากการทำแบบประเมิน แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันอุบัติเหตุ`;
    }

    if (riskData?.accident_sum_score === 2.5) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันการอุบัติเหตุ`;
    }
  };

  // risk_car_accident
  const getCarAccidentText = () => {
    if (!riskData?.car_accident_sum_score) return "-";
    return `จากการทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงด้วยการ โอนความเสี่ยง`;
  };

  const getCarAccidentDesc = () => {
    if (!riskData?.car_accident_sum_score) return "";

    if (riskData?.car_accident_sum_score === 1) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' จากกาารทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยง ด้วยการทำประกันภัยภาคบังคับ พ.ร.บ.`
    }

    if (riskData?.car_accident_sum_score === 1.5) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' จากกาารทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้ เหมาะสมแนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันภัยภาคบังคับ พ.ร.บ.`
    }

    if (riskData?.car_accident_sum_score === 2) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' จากกาารทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันภัยรถยนต์ภาคสมัครใจ ชั้น1, ชั้น2 และ ภาคบังคับ พ.ร.บ.`
    }

    if (riskData?.car_accident_sum_score === 2.5) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' จากกาารทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม 'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันภัยรถยนต์ภาคสมัครใจ ชั้น2, ชั้น3 และ ภาคบังคับ พ.ร.บ.`
    }

    if (riskData?.car_accident_sum_score === 3) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' จากกาารทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม 'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันภัยรถยนต์ภาคสมัครใจ ชั้น1, ชั้น2, ชั้น3 และ ภาคบังคับ พ.ร.บ.`
    }
    // return " จากการทำแบบประเมิน 'โอนความเสี่ยง' จากกาารทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วย การทำประกันภัยภาคบังคับ พ.ร.บ. และประกันภัยภาคสมัครใจ";
    // return "'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วย การทำประกันภัยภาคบังคับ พ.ร.บ.";
  };

  const riskItems = useMemo(() => {
    const newRiskItems = [
      {
        label: "กรณีเสียชีวิต",
        icon: "risk_dead.svg",
        title: getRiskText(),
        desc: "",
      },
      {
        label: "กรณีเจ็บป่วย",
        icon: "risk_sick.svg",
        title: getSickText(),
        desc: getSickDesc(),
      },
      {
        label: "กรณีทุพพลภาพ",
        icon: "risk_diabled.svg",
        title: getDisabledText(),
        desc: "",
      },
      {
        label: "กรณีอุบัติเหตุ",
        icon: "risk_accident.svg",
        title: getAccidentText(),
        desc: "",
      },
      {
        label: "กรณีอุบัติเหตุทางรถยนต์",
        icon: "risk_car_accident.svg",
        title: getCarAccidentText(),
        desc: getCarAccidentDesc(),
      },
    ];
    return newRiskItems;
  }, [riskData]);

  const insuranceItems = useMemo(() => {
    const newInsuranceItems = [
      {
        label: "ประกันชีวิต",
        icon: "insurance_life.svg",
        desc: `เบี้ยหลักพันต่อเดือน สามารถคุ้มครองครอบครัวหลักล้าน ลดหย่อนภาษีได้ หากต้องการเน้นการคุ้มครอง ประกันยูนิตลิ้งค์ สามารถกำหนดทุนประกันสูงด้วยเบี้ยประกันที่จำกัดได้`,
      },
      {
        label: "ประกันทุพพลภาพ",
        icon: "risk_diabled.svg",
        desc: `เบี้ยหลักร้อยต่อเดือนคุ้มครองหลักล้าน หากเกิดเหตุทุพพลภาพถาวร เนื่องจากเจ็บป่วยหรืออุบัติเหตุ ไม่สามารถทำงานมีรายรับ ได้ มีเงินชดเชยมาใช้ในการดำรงชีพและดูแลครอบครัว`,
      },
      {
        label: "ประกันสุขภาพ",
        icon: "risk_sick.svg",
        desc: `คุณต้องเพิ่มการออมและการลงทุนคุณน่าจะลดค่าใช้จ่าย แล้วนำเงินมาเพิ่มการออมและลงทุนเพื่อเป้าหมายทางการเงิน`,
      },
    ];
    return newInsuranceItems;
  }, [riskData]);

  const insurance2Items = useMemo(() => {
    const newInsuranceItems = [
      {
        label: "ประกันสินทรัพย์อัคคีภัย",
        icon: "insurance_house.svg",
        desc: hasAccidentInsurance
          ? `ควรทบทวนกรมธรรม์ ประกันสินทรัพย์และอัคคีภัย ว่าได้รับความคุ้มครองเหมาะสมกับมูลค่าสินทรัพย์ในปัจจุบันหรือไม่ มิฉะนั้นหากเกิดความเสียหายมา บริษัทจะจ่ายตามสัดส่วน ไม่ใช่มูลค่าความเสียหายที่แท้จริง`
          : `สินทรัพย์ของคุณยังไม่มีการบริหารความเสี่ยงด้วยประกันอัคคีภัย เบี้ยหลักพันคุ้มครองหลักล้าน`,
      },
      {
        label: "ประกันรถยนต์",
        icon: "car_insuarance_all.png",
        desc: hasCarInsurance
          ? `ควรทบทวนกรมธรรม์ประกันอุบัติเหตุ ว่ามีความคุ้มครองเพียงพอต่อความจำเป็นหรือไม่ เบี้ยหลักพันคุ้มครองหลักแสน เบิกได้ทั้งอุบัติเหตุผู้ป่วยในและผู้ป่วยนอก รักษาจนกว่าจะหาย ตามวงเงินประกัน`
          : `คุณลืมกรอกข้อมูลค่าเบี้ยประกันรถยนต์หรือไม่ ถ้าคุณไม่ได้ซื้อประกันรถยนต์ภาคบังคับ/ภาคสมัครใจ เกิดเหตุไม่คาดฝันขึ้นมา โดนฟ้องร้องหมดตัวเลยนะครับ เบี้ยประกันภาคบังคับหลักร้อยต่อปีคุ้มครองหลักแสน ประกันภาคสมัครใจ  เบี้ยหลักพันคุ้มครองหลักแสน`,
      },
    ];
    return newInsuranceItems;
  }, [riskData]);

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText title="บริหารความเสี่ยง" icon="/images/payment_pdf.svg" />
      <PdfCard className={"flex flex-col space-y-3"} >
        {/* บริหารความเสี่ยง */}
        {riskItems?.map((item, index) => {
          return (
            <PdfCardWhite key={index} className={"flex flex-col"}>
              <div className="flex items-center justify-between mx-1">
                <div className="flex">
                  <div>
                    <img
                      src={`/images/${item.icon}`}
                      className="w-[18px] h-[18px]"
                    />
                  </div>
                  <div className="ml-1 font-[500] text-[11px] my-1 whitespace-nowrap pr-1 ">
                    {item.label}
                  </div>
                </div>
                
              </div>
              <div className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_12," pl-6")}>
                  {item.title}
                </div>
              {item.desc && (
                <div
                  className={cn(
                    "flex justify-center items-center text-center px-20 mt-1",
                    STYLE_PDF_TEXT_NORMAL_10,
                    { "px-0": item.label === "กรณีเจ็บป่วย" }
                  )}
                >
                  {item.desc}
                </div>
              )}
            </PdfCardWhite>
          );
        })}
      </PdfCard>

      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageRiskOne;
